import styled from 'styled-components';

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  position: fixed;
  top: 0;
  z-index: 9999;
  display: ${(props) => (props.drawerOpen ? 'block' : 'none')};
`;

export const SideDrawerContainer = styled.div`
  width: 26%;
  height: 100vh;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.16);
  background: #fff;
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  animation: sidedrawer 0.38s ease-in-out;
  transition: all 0.38s ease-in-out;
  display: block;

  @media (max-width: 720px) {
    width: 80%;
    padding-bottom: 20px;
  }

  @keyframes sidedrawer {
    from {
      transform: translate(-100%, 0);
    }
    to {
      transform: translate(0, 0);
    }
  }
`;
export const WaveLogoBox = styled.div`
  position: relative;
  background-image: linear-gradient(to bottom, #fceaa15c, #fff);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  padding-top: 31.5%;
`;

export const WaveLogo = styled.img`
  width: 120px;
  height: 100%;
  position: absolute;
  top: 0;
  margin: auto;
`;

export const MenuArrow = styled.img`
  width: 42px;
  height: 16px;
  padding: 0 10px;
  margin-left: auto;
  rotate: 180deg;

  &.down {
    rotate: 0deg;
  }
`;

export const LanguageSelect = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;

  span {
    color: #ef4e5e;
  }

  img {
    width: 14px;
    height: 14px;
    transform: rotate(90deg);
    margin-left: 3px;
  }
`;

export const SideScroll = styled.div`
  @media (min-width: 720px) {
    height: 100%;
    &::-webkit-scrollbar {
      width: 5px;

      @media (max-width: 720px) {
        width: 0;
      }
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }
  }
  height: calc(100% - 20px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 100px;
`;

export const ParentingContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 4px 12px 24px;

  padding-top: 10px;
  @media (min-width: 768px) {
    margin: 20px 12px 24px 45px;
  }
  /* border-bottom: ${(props) =>
    props.track ? '1px solid #dadada' : 'none'}; */

  & a {
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg 0% 2% / 60%);

    @media (max-width: 720px) {
      cursor: default;
    }
  }

  .lowOpacity {
    opacity: 0.6;
  }

  .communityIcon {
    height: 13px;
    cursor: default;
    margin-left: 6px;
  }
`;

export const ListItem = styled.li`
  list-style: none;
  margin-bottom: 1em;
`;

export const DropDownHeader = styled.div`
  margin-bottom: 0.4em;
  font-size: 13px;
  color: #ef4e5e;
  background: transparent;
  display: flex;
  align-items: center;

  img {
    width: 14px;
    height: 14px;
    margin-left: 4px;
    transform: rotate(90deg);
  }
`;

export const SideBarContactUs = styled.div`
  width: 100%;
  margin: 12px 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg 0% 2% / 60%);
  @media (min-width: 768px) {
    margin: 12px 12px 24px 45px;
  }

  &.lowOpacity {
    opacity: 0.6;
  }
`;

export const SocialImagesContainer = styled.div`
  background-color: #fff;
  height: 140px;
  padding-top: 20px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: #fff;
  width: 90%;
  padding-left: 28px;
  padding-right: 28px;
  @media (min-width: 768px) {
    margin: 0 10px 0 45px;
  }

  img {
    width: 20px;
    height: 20px;
    opacity: 0.6;
    margin-right: 10px;
    @media (min-width: 768px) {
      cursor: pointer;
    }
  }
`;

export const CopyRightMylo = styled.p`
  font-size: 11px;
  color: #04040473;
  margin-top: 8px;
`;

export const DropDownList = styled.ul`
  margin: 0;
  position: absolute;
  right: 8px;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: hsl(0deg, 0%, 0%, 87%);
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;

  &:first-child {
    padding-top: 0.8em;
  }
`;

export const CategoryScroll = styled.div`
  height: calc(100vh - 130px);
  overflow-y: scroll;
  padding: 0 6px 10px 40px;
`;

export const TrackOrdersection = styled.div`
  display: flex;
  align-items: center;
  /* border-bottom: ${(props) =>
    props.track ? '1px solid #dadada' : 'none'}; */
  flex-shrink: 0;

  & p {
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg 0% 2% / 99%);
  }

  &.low {
    opacity: 0.4;
  }

  @media (min-width: 768px) {
    cursor: pointer;
    margin: 12px 12px 24px 45px;
  }
  justify-content: space-between;
  padding: 0 24px 0 28px;
`;

export const WhatsappHelpIcon = styled.div`
  margin: 12px 12px 24px;
  display: flex;
  align-items: center;
  cursor: default !important;

  &.low {
    opacity: 0.4;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg 0% 2% / 60%);
  }
`;
export const SideDrawerHelpButton = styled.div`
  margin: 12px ${(props) => (props.extraMargin ? '28px 24px' : '12px 12px')};
  display: flex;
  align-items: center;
  cursor: default !important;

  &.low {
    opacity: 0.4;
  }

  font-size: 14px;
  font-weight: 500;
  color: hsl(0deg 0% 2% / 60%);
  @media (min-width: 768px) {
    cursor: pointer !important;
    margin: 12px ${(props) => (props.extraMargin ? '63px 24px' : '45px 12px')};
  }
`;

export const MenuList = styled.div``;
export const L0BottomSpan = styled.span`
  border-bottom: solid 1px #dadada;
  width: 100%;
  margin: ${(props) => (props.showMargin ? '16px 0 0' : 'auto')};
  display: block;
`;

export const ExtraHeight = styled.div`
  height: 60px;
`;
//  l2 Category Padding Increase on 20/02/2023
export const MenuListTitle = styled.div`
  font-size: ${(props) => 14 - props.childlevel / 2}px;
  color: #000;
  font-weight: ${(props) => (props.childlevel > 1 ? 'normal' : '500')};
  display: flex;
  justify-content: ${(props) =>
    props.parentingDrawer ? 'flex-start' : 'space-between'};
  align-items: center;
  column-gap: 8px;
  margin: ${(props) => 14 - props.childlevel * 1}px 0;
  padding: ${(props) =>
    props.childlevel == 1 || props.childlevel == 0
      ? '0 20px 0 28px'
      : props.ltwoCat
        ? `0 20px 0  ${20 + props.childlevel * 20}px`
        : props.parentingDrawerltwo
          ? '0 20px 0 40px'
          : `0 ${20 + props.childlevel * 3}px`};

  & p {
    text-transform: capitalize;
    width: 100%;

    &.ellipsisText {
      width: 95%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &.lowOpacity {
    opacity: 0.6;
  }

  &.blurred {
  }

  @media (min-width: 768px) {
    cursor: pointer;
    padding: ${(props) =>
      props.ltwoCat && props.childlevel > 1
        ? `0 20px 0  ${45 + props.childlevel * 20}px`
        : props.parentingDrawerltwo && props.childlevel > 1
          ? '0 20px 0 45px'
          : `0 20px 0 ${45 + props.childlevel * 3}px`};
  }

  .lowOpacity {
    opacity: 0.6;
  }

  &.l3padding {
    padding: 0 20px;
  }

  .brandImg {
    width: 50%;
    cursor: default;
    margin-left: -10px;
  }
`;

export const LtwoCategoryBg = styled.div`
  .seeMoreText {
    font-size: 14px;
    font-weight: 500;
    padding: 20px 20px 20px 28px;
    color: #000;
    height: 52px;
    width: 100%;
    display: flex;
    align-items: center;
    column-gap: 3px;

    img {
      margin-top: 3px;
      height: 10px;
      width: 10px;
    }

    .lowOpacity {
      opacity: 0.4;
    }

    @media (min-width: 768px) {
      padding: 20px 20px 20px 48px;
    }
  }

  @media (min-width: 768px) {
    cursor: pointer;
  }
  position: relative;

  &.borderLeft {
    border-left: 1px solid #7070701f;
    margin-left: auto;
    width: 85%;
    padding: 4px 0;
  }
`;

export const ListItems = styled.div`
  font-size: 13px;
  color: #6e6e6e;
  padding: 10px 20px 10px 34px;
  display: flex;
  justify-content: space-between;

  & img {
    width: 18px;
    height: 20px;
  }
`;

export const MenuTitleImage = styled.img`
  width: 16px;
  height: 16px;
`;

export const MyRefundsContainer = styled.div`
  &.lowOpacity {
    opacity: 0.4;
  }

  font-size: 14px;
  color: #000;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 8px;
  margin: 14px 0;
  padding: 0 24px 0 28px;

  img {
    width: 22px;
  }
`;
export const MyloAppbanner = styled.div`
  padding: 2px 12px 12px;

  img {
    width: 100%;
    border-radius: 10px;
  }
`;

export const CategoryHeader = styled.div`
  font-size: 10px;
  font-weight: 600;
  font-family: Montserrat;
  font-stretch: normal;
  font-style: normal;
  color: rgba(0, 0, 0, 0.42);
  text-transform: uppercase;
  padding: 16px 20px;
  letter-spacing: 0.5px;

 
`;

export const CategoryList = styled.div`

  overflow-y: auto;
  max-height: calc(100vh - 200px);
`;

export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 5px 18px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  border-radius: 8px;
  margin: 4px 16px;
  background: transparent;

  // &:hover {
  //   background: rgba(0, 0, 0, 0.02);
  // }

  // &:active {
  //   transform: scale(0.98);
  // }
`;

export const CategoryThumbnail = styled.div`
  width: 60px;
  height: 60px;
  min-width: 60px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 12px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CategoryContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const CategoryTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
`;

export const CategoryDescription = styled.div`
  font-size: 11px;
 font-family: Montserrat;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const CategoryChevron = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  color: #666;
`;
